import { useCallback } from "react"
import { IconButton } from "@material-ui/core"
import FirstPageIcon from "@material-ui/icons/FirstPage"
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft"
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight"
import LastPageIcon from "@material-ui/icons/LastPage"
import { css } from "@emotion/css"
import { AgGridCustomPaginationActionsProps } from "../types"
import { useI18n } from "providers/I18n"

export const AgGridCustomPaginationActions = (
  props: AgGridCustomPaginationActionsProps,
) => {
  const { paginationData, page, gridRef } = props
  const { t } = useI18n()

  const handleFirstPageButtonClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      gridRef?.current?.api?.paginationGoToFirstPage()
    },
    [gridRef],
  )

  const handleBackButtonClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      gridRef?.current?.api?.paginationGoToPreviousPage()
    },
    [gridRef],
  )

  const handleNextButtonClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      gridRef?.current?.api?.paginationGoToNextPage()
    },
    [gridRef],
  )

  const handleLastPageButtonClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      gridRef?.current?.api?.paginationGoToLastPage()
    },
    [gridRef],
  )

  const buildTotalPagesText = () => {
    return paginationData.isTotalPagesFetched
      ? paginationData.totalPages
      : t("reporting.aggrid.custompagination.morePages")
  }

  return (
    <div
      className={css`
        flex-shrink: 0;
        margin-left: 1rem;
      `}
    >
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0}>
        <FirstPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
        <KeyboardArrowLeft />
      </IconButton>
      <span>
        {t("reporting.aggrid.custompagination.page")}{" "}
        {paginationData.currentPage + 1}{" "}
        {t("reporting.aggrid.custompagination.pageOf")} {buildTotalPagesText()}
      </span>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={paginationData.currentPage + 1 === paginationData.totalPages}
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={
          !paginationData.isTotalPagesFetched ||
          paginationData.currentPage + 1 === paginationData.totalPages
        }
      >
        <LastPageIcon />
      </IconButton>
    </div>
  )
}
